var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1282 4694 c-90 -67 -164 -125 -165 -128 -1 -3 115 -161 257 -351 l259 -346 -32 -37 c-107 -126 -207 -301 -255 -447 -62 -188 -59 -144 -63 -1167 l-4 -938 216 0 215 0 0 -425 0 -425 210 0 210 0 0 425 0 425 430 0 430 0 0 -425 0 -425 210 0 210 0 0 425 0 425 215 0 216 0 -4 937 c-4 1024 -1 980 -63 1168 -48 146 -148 321 -255 447 l-32 37 238 318 c131 175 249 332 261 348 l23 31 -169 127 -170 127 -261 -347 c-143 -192 -264 -347 -267 -346 -4 1 -43 18 -87 37 -44 19 -127 48 -185 63 -99 26 -117 28 -310 27 -190 0 -212 -2 -302 -26 -53 -15 -137 -43 -186 -62 -49 -20 -92 -36 -95 -36 -3 0 -122 153 -263 340 -141 187 -259 342 -263 344 -3 2 -79 -52 -169 -120z m1488 -879 c96 -25 256 -106 331 -168 125 -104 215 -236 271 -397 l33 -95 3 -722 3 -723 -851 0 -851 0 3 723 3 722 33 95 c105 303 339 509 652 576 83 17 282 12 370 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 2135 l0 -855 215 0 215 0 -2 853 -3 852 -212 3 -213 2 0 -855z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4057 2983 c-4 -3 -7 -388 -7 -855 l0 -848 215 0 215 0 0 855 0 855 -208 0 c-115 0 -212 -3 -215 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIcon);
export default __webpack_public_path__ + "static/media/bot-icon.30fd578b425345f4c08f49bd454daad1.svg";
export { ForwardRef as ReactComponent };